import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomerService } from '../shared/customer/customer.service';
import { LoginService } from '../shared/user-login/login.service';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css'],
    standalone: false
})
export class UserProfileComponent implements OnInit {
  userDetails;
  role: string;
  paymentDetails;
  loading: boolean = true

  constructor(private loginService: LoginService , private customerService: CustomerService,private router : Router) {}

  ngOnInit() {
    this.loginService.getUserProfile().subscribe(
      res => {
        this.userDetails = res['user'];
        this.role = this.userDetails.role;
        if(this.role === 'CUSTOMER'){
          this.customerService.getPaymentInfo().subscribe(res => {
            this.paymentDetails = res['paymentInfo']
            console.log('got payment info', this.paymentDetails)
            this.loading = false;
          }, err => {
            console.log('error', err)
          })
        }
        this.loading = false;
        console.log('got logged in user', this.userDetails, this.role);
      },
      err => {
        console.log('Did not get user', err);
        this.loading = false;
        this.router.navigateByUrl('/signin');
      }
    )
  }

  onLogout(){
    this.loginService.deleteToken();
    this.router.navigateByUrl('/signin');
  }
}

